<template>
  <div class="stock-item">
    <div class="row align-items-center">
      <div class="col-lg-5">
        <div class="row row--tight-gutters align-items-center mb-3 mb-lg-0">
          <div class="col-3 stock-item__thumb">
            <img
              class="img-fluid h-auto"
              :src="image"
              alt=""
              width="128"
              height="128"
            >
          </div>

          <div class="col-9">
            <h3 class="stock-item__title">
              {{ offerItem.dimensions }} <span class="stock-item__label">({{ offerItem.dimensions_label }})</span>
            </h3>
            {{ offerItem.description }}
          </div>
        </div>
      </div>

      <div class="col-lg-7">
        <div class="d-flex">
          <div class="pr-3 pr-lg-5 pr-xl-6">
            <strong class="d-block">{{ i18n.stock }}</strong>
            <span class="color-primary">{{ offerItem.stock }} st.</span>
          </div>

          <div class="pr-3 pr-lg-5 pr-xl-6">
            <strong class="d-block">{{ i18n.min_amount }}</strong>
            {{ offerItem.minimum_amount }} st.
          </div>

          <div class="ml-auto stock-item__action">
            <a :href="offerItem.offer_url" class="btn btn--secondary" target="_blank">
              {{ i18n.request_offer }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    offerItem: Object,
  },

  computed: {
    image() {
      if (typeof this.offerItem.image === 'undefined' || !this.offerItem.image) {
        return '/front_assets/img/default-box.png';
      }

      return this.offerItem.image;
    },
  },
};
</script>

<style scoped>
.stock-item {
  border-bottom: 1px solid #d3d3d3;
  padding-bottom: 1rem;
  margin-bottom: 1rem;
}

.stock-item:last-child {
  border-bottom: 0;
  margin-bottom: 0;
  padding-bottom: 0;
}

.stock-item__title {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: .25rem;
}

.stock-item__label {
  font-size: .75rem;
  color: #999;
}

@media (max-width: 375px) {
  .stock-item {
    font-size: .875rem;
  }

  .stock-item .btn {
    font-size: .875rem;
  }
}
</style>
